import { useLanguage } from '../contexts/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { SEOHead } from '../components/SEOHead';
import { Monitor, Users, Palmtree, Star, Info, Download } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function CalendarPage() {
  const { language } = useLanguage();
  const es = language === 'es';

  const legend = [
    { icon: <Monitor className="h-4 w-4" />, color: '#1D1D1F', label: es ? 'Clases Virtuales' : 'Virtual Classes', sub: es ? 'Cada nivel en su dia asignado' : 'Each level on assigned day' },
    { icon: <Users className="h-4 w-4" />, color: '#8B1A2B', label: es ? 'Clase Presencial (MA)' : 'In-Person Class (MA)', sub: es ? 'Sabado o domingo · Massachusetts' : 'Saturday or Sunday · Massachusetts' },
    { icon: <Palmtree className="h-4 w-4" />, color: '#E63946', label: es ? 'Vacaciones' : 'Holidays', sub: es ? 'No hay clases' : 'No classes' },
    { icon: <Star className="h-4 w-4" />, color: '#FFB800', label: es ? 'Evento Especial' : 'Special Event', sub: es ? 'Fiesta fin de curso' : 'End of year party' },
  ];

  const trimesters = [
    {
      id: 'T1', color: '#E63946', bg: '#FFF5F5',
      title: es ? 'Trimestre 1 · 10 Clases' : 'Trimester 1 · 10 Classes',
      period: es ? 'Del 14 de septiembre al 23 de noviembre de 2026' : 'September 14 to November 23, 2026',
      months: [
        {
          name: es ? 'Septiembre 2026' : 'September 2026',
          weeks: [
            { week: es ? 'Semana del 14' : 'Week of Sep 14', type: 'class' },
            { week: es ? 'Semana del 21' : 'Week of Sep 21', type: 'class' },
            { week: es ? 'Semana del 28' : 'Week of Sep 28', type: 'class' },
          ]
        },
        {
          name: es ? 'Octubre 2026' : 'October 2026',
          weeks: [
            { week: es ? 'Semana del 5' : 'Week of Oct 5', type: 'class' },
            { week: es ? '17 o 18 de octubre' : 'October 17 or 18', type: 'presencial', label: es ? 'Clase presencial (MA)' : 'In-person class (MA)' },
            { week: es ? 'Semana del 19' : 'Week of Oct 19', type: 'class' },
            { week: es ? 'Semana del 26' : 'Week of Oct 26', type: 'class' },
          ]
        },
        {
          name: es ? 'Noviembre 2026' : 'November 2026',
          weeks: [
            { week: es ? 'Semana del 2' : 'Week of Nov 2', type: 'class' },
            { week: es ? 'Semana del 9' : 'Week of Nov 9', type: 'class' },
            { week: es ? 'Semana del 16' : 'Week of Nov 16', type: 'class' },
            { week: es ? 'Semana del 23' : 'Week of Nov 23', type: 'vacation', label: es ? 'Vacaciones — Accion de Gracias' : 'Thanksgiving Break' },
          ]
        },
      ]
    },
    {
      id: 'T2', color: '#7B61FF', bg: '#F5F3FF',
      title: es ? 'Trimestre 2 · 10 Clases' : 'Trimester 2 · 10 Classes',
      period: es ? 'Del 30 de noviembre de 2026 al 22 de febrero de 2027' : 'November 30, 2026 to February 22, 2027',
      months: [
        {
          name: es ? 'Noviembre 2026' : 'November 2026',
          weeks: [
            { week: es ? 'Semana del 30' : 'Week of Nov 30', type: 'class' },
          ]
        },
        {
          name: es ? 'Diciembre 2026' : 'December 2026',
          weeks: [
            { week: es ? 'Semana del 7' : 'Week of Dec 7', type: 'class' },
            { week: es ? 'Semana del 14' : 'Week of Dec 14', type: 'class' },
            { week: es ? 'Semana del 21' : 'Week of Dec 21', type: 'vacation', label: es ? 'Vacaciones' : 'Holidays' },
            { week: es ? 'Semana del 28' : 'Week of Dec 28', type: 'vacation', label: es ? 'Vacaciones' : 'Holidays' },
          ],
          special: es ? 'Vacaciones de Navidad' : 'Christmas Break'
        },
        {
          name: es ? 'Enero 2027' : 'January 2027',
          weeks: [
            { week: es ? 'Semana del 4' : 'Week of Jan 4', type: 'class' },
            { week: es ? 'Semana del 11' : 'Week of Jan 11', type: 'class' },
            { week: es ? 'Semana del 18' : 'Week of Jan 18', type: 'class' },
            { week: es ? 'Semana del 25' : 'Week of Jan 25', type: 'class' },
          ]
        },
        {
          name: es ? 'Febrero 2027' : 'February 2027',
          weeks: [
            { week: es ? '6 o 7 de febrero' : 'February 6 or 7', type: 'presencial', label: es ? 'Clase presencial (MA)' : 'In-person class (MA)' },
            { week: es ? 'Semana del 8' : 'Week of Feb 8', type: 'class' },
            { week: es ? 'Semana del 15' : 'Week of Feb 15', type: 'vacation', label: es ? 'Vacaciones de invierno' : 'Winter Break' },
            { week: es ? 'Semana del 22' : 'Week of Feb 22', type: 'class' },
          ]
        },
      ]
    },
    {
      id: 'T3', color: '#34C759', bg: '#F0FFF4',
      title: es ? 'Trimestre 3 · 10 Clases' : 'Trimester 3 · 10 Classes',
      period: es ? 'Del 1 de marzo al 16 de mayo de 2027' : 'March 1 to May 16, 2027',
      months: [
        {
          name: es ? 'Marzo 2027' : 'March 2027',
          weeks: [
            { week: es ? 'Semana del 1' : 'Week of Mar 1', type: 'class' },
            { week: es ? 'Semana del 8' : 'Week of Mar 8', type: 'vacation', label: es ? 'Vacaciones de invierno-primavera' : 'Winter-Spring Break' },
            { week: es ? 'Semana del 15' : 'Week of Mar 15', type: 'class' },
            { week: es ? 'Semana del 22' : 'Week of Mar 22', type: 'class' },
            { week: es ? 'Semana del 29' : 'Week of Mar 29', type: 'class' },
          ]
        },
        {
          name: es ? 'Abril 2027' : 'April 2027',
          weeks: [
            { week: es ? 'Semana del 5' : 'Week of Apr 5', type: 'class' },
            { week: es ? 'Semana del 12' : 'Week of Apr 12', type: 'class' },
            { week: es ? 'Semana del 19' : 'Week of Apr 19', type: 'vacation', label: es ? 'Vacaciones de primavera' : 'Spring Break' },
            { week: es ? 'Semana del 26' : 'Week of Apr 26', type: 'class' },
          ]
        },
        {
          name: es ? 'Mayo 2027' : 'May 2027',
          weeks: [
            { week: es ? 'Semana del 3' : 'Week of May 3', type: 'class' },
            { week: es ? 'Semana del 10' : 'Week of May 10', type: 'class' },
            { week: es ? '15 o 16 de mayo' : 'May 15 or 16', type: 'special', label: es ? 'Clase presencial (MA) + Fiesta de Final de Curso' : 'In-person class (MA) + End of Year Party' },
          ]
        },
      ]
    },
  ];

  const typeStyles = {
    class: { bg: 'bg-white', text: 'text-[#1D1D1F]', dot: 'bg-[#1D1D1F]' },
    presencial: { bg: 'bg-[#8B1A2B]/5', text: 'text-[#8B1A2B]', dot: 'bg-[#8B1A2B]' },
    vacation: { bg: 'bg-[#E63946]/5', text: 'text-[#E63946]', dot: 'bg-[#E63946]' },
    special: { bg: 'bg-[#FFB800]/10', text: 'text-[#8B6914]', dot: 'bg-[#FFB800]' },
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead />
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="max-w-7xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="text-sm font-semibold text-[#E63946] uppercase tracking-wider mb-2" data-testid="calendar-subtitle">
              {es ? 'Calendario Escolar' : 'School Calendar'}
            </p>
            <h1 className="text-4xl sm:text-5xl font-bold text-[#1D1D1F] mb-3" data-testid="calendar-title">
              Colegio ARCE 2026-2027
            </h1>
            <p className="text-[#86868B] max-w-xl mx-auto">
              {es
                ? '30 semanas de clases divididas en 3 trimestres. Cada trimestre incluye 10 semanas con clases virtuales.'
                : '30 weeks of classes divided into 3 trimesters. Each trimester includes 10 weeks of virtual classes.'}
            </p>
            <div className="mt-6">
              <a
                href="/calendario-arce-2026-2027.jpg"
                download="Calendario-ARCE-2026-2027.jpg"
                data-testid="download-calendar-btn"
              >
                <Button className="rounded-xl bg-[#E63946] hover:bg-[#D62828] text-white px-6 py-5">
                  <Download className="h-5 w-5 mr-2" />
                  {es ? 'Descargar Calendario (PDF)' : 'Download Calendar (PDF)'}
                </Button>
              </a>
            </div>
          </div>

          {/* Legend */}
          <div className="flex flex-wrap justify-center gap-4 mb-10">
            {legend.map((item, i) => (
              <div key={i} className="flex items-center gap-2 px-4 py-2 bg-[#F5F5F7] rounded-full">
                <span style={{ color: item.color }}>{item.icon}</span>
                <span className="text-xs font-semibold text-[#1D1D1F]">{item.label}</span>
              </div>
            ))}
          </div>

          {/* Trimesters Grid */}
          <div className="grid lg:grid-cols-3 gap-6 mb-16">
            {trimesters.map((tri) => (
              <div key={tri.id} className="rounded-2xl border border-black/5 overflow-hidden" data-testid={`trimester-${tri.id}`}>
                {/* Trimester Header */}
                <div className="px-5 py-4 text-white" style={{ backgroundColor: tri.color }}>
                  <h2 className="font-bold text-base">{tri.title}</h2>
                  <p className="text-white/80 text-xs mt-0.5">{tri.period}</p>
                </div>

                {/* Months */}
                <div className="divide-y divide-black/5">
                  {tri.months.map((month, mi) => (
                    <div key={mi}>
                      <div className="px-5 py-2.5" style={{ backgroundColor: tri.bg }}>
                        <h3 className="text-xs font-bold uppercase tracking-wide" style={{ color: tri.color }}>{month.name}</h3>
                      </div>
                      <div className="divide-y divide-black/5">
                        {month.weeks.map((w, wi) => {
                          const style = typeStyles[w.type];
                          return (
                            <div key={wi} className={`px-5 py-2.5 flex items-center justify-between gap-2 ${style.bg}`}>
                              <div className="flex items-center gap-2.5 min-w-0">
                                <span className={`w-2 h-2 rounded-full flex-shrink-0 ${style.dot}`} />
                                <span className={`text-sm ${w.type === 'presencial' || w.type === 'special' ? 'font-semibold' : ''} ${style.text}`}>
                                  {w.week}
                                </span>
                              </div>
                              <span className={`text-xs font-medium flex-shrink-0 ${style.text}`}>
                                {w.label || (es ? 'Clases' : 'Classes')}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                      {month.special && (
                        <div className="px-5 py-2 bg-[#FFB800]/10 text-center">
                          <span className="text-xs font-semibold text-[#8B6914] italic">
                            {month.special}
                          </span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {/* Footer */}
                <div className="px-5 py-3 bg-[#F5F5F7] flex items-center gap-2">
                  <span className="text-2xl font-black" style={{ color: tri.color }}>10</span>
                  <span className="text-xs text-[#86868B] leading-tight">
                    {es ? 'semanas con clases virtuales' : 'weeks of virtual classes'}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Important Notes */}
          <div className="max-w-3xl mx-auto">
            <div className="p-6 bg-[#F5F5F7] rounded-2xl flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-[#E63946]/10 flex items-center justify-center flex-shrink-0">
                <Info className="h-5 w-5 text-[#E63946]" />
              </div>
              <div className="space-y-2 text-sm text-[#6E6E73]">
                <p className="font-semibold text-[#1D1D1F]">{es ? 'Importante' : 'Important'}</p>
                <p>{es ? 'Las clases presenciales son sabados o domingos en Massachusetts (fechas indicadas).' : 'In-person classes are on Saturdays or Sundays in Massachusetts (indicated dates).'}</p>
                <p>{es ? 'Calendario sujeto a cambios. Se avisara con antelacion.' : 'Calendar subject to changes. Advance notice will be given.'}</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
